/**
 * @desc 导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.certMain.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/certMain/export`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
